const artistsWishlistFR = {
    "view": {
        "table": {
            "title": "Votre liste de souhaits d'artistes",
            "column": {
                "artist_name": "Nom de l'artiste",
                "spotify_id": "ID Spotify",
                "followers": "Abonnés",
                "popularity": "Popularité (%)",
                "action": "Action"
            },
            "dropdown": {
                "action": "Action",
                "addAsArtist": "Ajouter en tant qu'artiste",
                "delete": "Supprimer"
            },
            "button": {
                "export_csv": "Exporter CSV"
            },
            "placeholder": {
                "search": "Rechercher..."
            },
            "message": {
                "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !"
            }
        },
        "modal": {
            "removeArtist": {
                "header": "Retirer l'artiste {{artistName}} de la liste de souhaits",
                "body": "Êtes-vous sûr de vouloir retirer l'artiste {{artistName}} de votre liste de souhaits ?"
            }
        },
        "message": {
            "subscriptionUpgrade": "Votre plan d'abonnement actuel ne prend pas en charge cette fonctionnalité. Veuillez <1>mettre à niveau</1> votre plan d'abonnement pour bénéficier de cette fonctionnalité.",
            "subscriptionExpired": "Votre abonnement a expiré. Veuillez <1>reprendre</1> votre abonnement pour bénéficier de cette fonctionnalité.",
            "noAccess": "Vous n'avez pas accès à ce module, veuillez contacter l'équipe de support pour plus d'informations."
        }
    }
};

export default artistsWishlistFR;